import { z } from "zod";

const phoneRegex = new RegExp(
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/,
);

export const interestFormSchema = z.object({
  firstName: z.string().trim().min(1, "First name is required"),
  lastName: z.string().trim().min(1, "Last name is required"),
  email: z.string().trim().email({ message: "Invalid email address" }),
  phoneNumber: z.string().regex(phoneRegex, "Invalid number"),
  message: z.string().min(20, "Message must be at least 20 characters"),
  specialties: z
    .array(
      z.enum([
        "Website design",
        "UX design",
        "User research",
        "Content creation",
        "Strategy & consulting",
        "Other",
      ]),
    )
    .min(1, { message: "You must select at least one specialty" }),
});

export type TInterestFormSchema = z.infer<typeof interestFormSchema>;
